var _defs, _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKenya(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    strokeMiterlimit: 10,
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    viewBox: "0 0 13.9444 8.65078",
    width: "100%",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "ArtboardFrame"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 8.65078,
    width: 13.9444,
    x: 0,
    y: 0
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ArtboardFrame)",
    id: "Untitled"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00714822 0L13.93 0L13.93 0L13.93 8.659L13.93 8.659L0.00714822 8.659L0.00714822 8.659L0.00714822 0L0.00714822 0Z",
    fill: "#ffffff",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00714822 0L13.93 0L13.93 0L13.93 2.5977L13.93 2.5977L0.00714822 2.5977L0.00714822 2.5977L0.00714822 0L0.00714822 0Z",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00714822 3.03065L13.93 3.03065L13.93 3.03065L13.93 5.62835L13.93 5.62835L0.00714822 5.62835L0.00714822 5.62835L0.00714822 3.03065L0.00714822 3.03065Z",
    fill: "#bb0000",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00714822 6.0613L13.93 6.0613L13.93 6.0613L13.93 8.659L13.93 8.659L0.00714822 8.659L0.00714822 8.659L0.00714822 6.0613L0.00714822 6.0613Z",
    fill: "#006600",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.31066 6.90014L5.41114 6.95426L8.12103 2.57557C8.27953 2.53595 8.36654 2.39534 8.45356 2.25474C8.51157 2.161 8.74362 1.78606 8.84419 1.29885C8.44218 1.6237 8.21013 1.99865 8.15212 2.09238C8.0651 2.23299 7.97809 2.37359 8.02055 2.52145L5.31066 6.90014Z",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.31066 6.90014L5.41114 6.95426L8.12103 2.57557C8.27953 2.53595 8.36654 2.39534 8.45356 2.25474C8.51157 2.161 8.74362 1.78606 8.84419 1.29885C8.44218 1.6237 8.21013 1.99865 8.15212 2.09238C8.0651 2.23299 7.97809 2.37359 8.02055 2.52145L5.31066 6.90014Z",
    fill: "#ffffff",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.62648 6.90014L8.526 6.95426L5.8161 2.57557C5.65761 2.53595 5.5706 2.39534 5.48358 2.25474C5.42557 2.161 5.19352 1.78606 5.09295 1.29885C5.49496 1.6237 5.727 1.99865 5.78502 2.09238C5.87203 2.23299 5.95905 2.37359 5.91658 2.52145L8.62648 6.90014Z",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.62648 6.90014L8.526 6.95426L5.8161 2.57557C5.65761 2.53595 5.5706 2.39534 5.48358 2.25474C5.42557 2.161 5.19352 1.78606 5.09295 1.29885C5.49496 1.6237 5.727 1.99865 5.78502 2.09238C5.87203 2.23299 5.95905 2.37359 5.91658 2.52145L8.62648 6.90014Z",
    fill: "#ffffff",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.86634 5.62835C6.04038 6.0613 6.6205 6.9272 6.96857 6.9272C7.31664 6.9272 7.89676 6.0613 8.07079 5.62835L8.07079 3.03065C7.89676 2.5977 7.31664 1.7318 6.96857 1.7318C6.6205 1.7318 6.04038 2.5977 5.86634 3.03065L5.86634 5.62835Z",
    fill: "#bb0000",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.07079 5.62835C8.24483 5.1954 8.36085 4.76245 8.36085 4.3295C8.36085 3.89655 8.24483 3.4636 8.07079 3.03065C7.89676 3.4636 7.78074 3.89655 7.78074 4.3295C7.78074 4.76245 7.89676 5.1954 8.07079 5.62835Z",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.86634 5.62835C5.69231 5.1954 5.57629 4.76245 5.57629 4.3295C5.57629 3.89655 5.69231 3.4636 5.86634 3.03065C6.04038 3.4636 6.1564 3.89655 6.1564 4.3295C6.1564 4.76245 6.04038 5.1954 5.86634 5.62835Z",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.73652 4.3295C6.73652 4.15016 6.84041 4.00479 6.96857 4.00479C7.09673 4.00479 7.20062 4.15016 7.20062 4.3295C7.20062 4.50883 7.09673 4.65421 6.96857 4.65421C6.84041 4.65421 6.73652 4.50883 6.73652 4.3295Z",
    fill: "#ffffff",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.02658 4.64609C7.02658 4.64609 7.25863 5.07904 7.25863 5.78259C7.25863 6.48613 7.02658 6.91908 7.02658 6.91908L7.02658 4.64609Z",
    fill: "#ffffff",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.91056 4.0129C6.91056 4.0129 6.67851 3.57995 6.67851 2.87641C6.67851 2.17287 6.91056 1.73992 6.91056 1.73992L6.91056 4.0129Z",
    fill: "#ffffff",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.91056 4.64609C6.91056 4.64609 6.67851 5.07904 6.67851 5.78259C6.67851 6.48613 6.91056 6.91908 6.91056 6.91908L6.91056 4.64609Z",
    fill: "#ffffff",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.02658 4.0129C7.02658 4.0129 7.25863 3.57995 7.25863 2.87641C7.25863 2.17287 7.02658 1.73992 7.02658 1.73992L7.02658 4.0129Z",
    fill: "#ffffff",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKenya);
export default __webpack_public_path__ + "static/media/kenya.d2a058035bc9c472e8e98dbd75ee03e5.svg";
export { ForwardRef as ReactComponent };